(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.colorDuetFormatterV1 = {
    attach: function (context, settings) {
      // functionality for add to cart
      $('.js-color-duet-add-to-cart').once().click(function () {
        prodcat.ui.addToCart({ skuData: { SKU_BASE_ID: $(this).data('skus').replace(/,\s*$/, '').split(',') } });

        return false;
      });
      $('.color-duet-category').wrapAll("<div class='color-duet-category-container' />");
      $('.js-color-duet-mobile__arrow').click(function () {
        event.preventDefault();
        parent.history.back(1);
      });
    }
  };
})(jQuery, Drupal);
